import styled from "styled-components";

export const Container = styled.div<{ $highlighted?: boolean }>`
    width: 100%;
    display: grid;
    grid-template-columns: 25px 1fr auto;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
    gap: 5px;
    border-radius: 6px;
    padding: 15px;
    padding-right: 20px;
    transition: all 0.3s ease;
    ${props => props.$highlighted && `
        border: 2px solid ${props.theme.colors.primaryRed400};
        background-color: rgba(229, 41, 64, 0.05);
        box-shadow: 0px 0px 8px 2px rgba(229, 41, 64, 0.2);
    `}

    @media (max-width: 768px) {
        grid-template-columns: 25px 1fr;
        grid-template-rows: auto auto;
        gap: 10px;
        align-items: flex-start;
        
        .right {
            grid-column: 2;
            grid-row: 2;
            align-items: flex-start;
            margin-top: 4px;
        }
    }

    @media (max-width: 640px){
        align-items: flex-start;
    }

    .icone {
        > svg {
            width: 18px;
            height: 18px;
            @media (max-width: 640px) {
                width: 22px;
                height: 25px;
            }
        }
    }

    .right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 8px;
        justify-content: center;
    }

    .data-right {
        display: flex;
        align-items: center;
        gap: 6px;
        color: ${(props: any) => props.theme.colors.c64748b};
        font-size: 12px;
        font-weight: 400;
        white-space: nowrap;
        flex-shrink: 0;

        svg {
            width: 14px;
            height: 14px;
            color: ${(props: any) => props.theme.colors.c64748b};
        }
    }

    .download {
        cursor: pointer;
        padding: 10px;
        height: 40px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
    
        &:hover {
            background-color: ${({ theme }) => theme.colors.interfacePure100};
        }
        > svg {
            width: 18px;
            height: 18px;
        }
        
        .spinner {
            animation: spin 1s linear infinite;
        }
        
        @keyframes spin {
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(360deg);
            }
        }
    }

    .meio {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 8px;
        min-width: 0;
        overflow: hidden;
        
        .top {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            width: 100%;
            min-width: 0;

            @media (max-width: 640px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 5px;
            }

            .top-left {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 0;
                flex: 1;
                min-width: 0;
                overflow: hidden;

                @media (max-width: 640px) {
                    width: 100%;
                }

                .nome {
                    font-size: 13px;
                    color: ${({ theme }) => theme.colors.c000000};
                    font-weight: 600;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    max-width: 600px;
                    margin: 0;
                    margin-right: 4px;
                    padding: 0;
                    flex-shrink: 1;
                    min-width: 0;
                }

                > svg {
                    width: 16px;
                    height: 16px;
                    color: ${({ theme }) => theme.colors.interfaceGray400 || '#9CA3AF'};
                    flex-shrink: 0;
                    margin: 0 4px;
                }

                .tamanho {
                    font-size: 12px;
                    color: ${({ theme }) => theme.colors.interfaceGray500 || '#6B7280'};
                    font-weight: 400;
                    white-space: nowrap;
                    flex-shrink: 0;
                    margin-left: 0;
                }
            }

        }

        .bottom {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 11px;
            font-weight: 400;
            flex-wrap: wrap;
            gap: 5px;
            min-width: 0;
            overflow: hidden;
            
            @media (max-width: 800px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 5px;
                > svg {
                 display: none;
                }
            }
            
            .enviado {
                display: flex;
                flex-direction: row;
                gap: 5px;
                align-items: center;
                flex-wrap: wrap;
                min-width: 0;
                overflow: hidden;
            }

            .tipo_responsavel {
                padding: 3px 8px;
                border-radius: 12px;
                font-size: 10px;
                font-weight: 500;
                background-color: rgb(252, 230, 230);
                color: rgb(239, 68, 68);
                text-transform: capitalize;
            }
        }

        .origem-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 6px;
            margin-top: 0;
            min-width: 0;
            overflow: hidden;
        }

        .origem-label {
            font-size: 11px;
            color: ${({ theme }) => theme.colors.interfaceGray500 || '#6B7280'};
            font-weight: 400;
            flex-shrink: 0;
        }

        .origem-chip {
            padding: 3px 8px;
            border-radius: 12px;
            font-size: 10px;
            font-weight: 500;
            background-color: rgba(245, 158, 11, 0.1);
            color: rgba(180, 83, 9, 1);
            border: 1px solid rgba(245, 158, 11, 0.3);
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            max-width: 200px;
            display: inline-block;
            flex-shrink: 1;
            min-width: 0;
        }
    }

    .menu-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .menu-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border: none;
        background: transparent;
        cursor: pointer;
        padding: 6px;
        border-radius: 6px;
        transition: all 0.2s ease;

        &:hover {
            background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F2F2F2'};
        }

        &:active {
            background-color: ${({ theme }) => theme.colors.interfacePure200 || '#CCCCCC'};
        }

        &:focus {
            outline: 2px solid ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
            outline-offset: 2px;
        }

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }
    }

    .menu-dropdown {
        position: fixed;
        background: ${(props: any) => props.theme.colors.interfacePure0};
        border-radius: 8px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
        min-width: 160px;
        z-index: 10000;
        padding: 4px;
    }

    .menu-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        cursor: pointer;
        border-radius: 6px;
        font-size: 14px;
        color: ${(props: any) => props.theme.colors.c1f2937};
        transition: background-color 0.2s ease;

        &:hover {
            background-color: ${(props: any) => props.theme.colors.cf3f4f6};
        }

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }

        svg {
            width: 16px;
            height: 16px;
        }
    }
`;